import { createReducer } from 'redux-act';

import {
  MASTER_CONFIG_FETCH_INIT, MASTER_CONFIG_FETCH_SUCCESS, MASTER_CONFIG_FETCH_FAIL,
  MASTER_CONFIG_CREATE_INIT, MASTER_CONFIG_CREATE_SUCCESS, MASTER_CONFIG_CREATE_FAIL,
  MASTER_CONFIG_UPDATE_INIT, MASTER_CONFIG_UPDATE_SUCCESS, MASTER_CONFIG_UPDATE_FAIL,
  MASTER_CONFIG_CLEAR,
} from 'state/actions/masterConfig';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
};

export const masterConfigReducer = createReducer(
  {
    [MASTER_CONFIG_FETCH_INIT]: (state) => ({ ...state, loading: true, error: null }),
    [MASTER_CONFIG_FETCH_SUCCESS]: (state, payload) => ({ ...state, list: payload.list || [], loading: false, error: null }),
    [MASTER_CONFIG_FETCH_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error }),
    [MASTER_CONFIG_CREATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [MASTER_CONFIG_CREATE_SUCCESS]: (state, payload) => ({ ...state, list: state.list.concat(payload.config), loading: false, error: null, success: true }),
    [MASTER_CONFIG_CREATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [MASTER_CONFIG_UPDATE_INIT]: (state) => ({ ...state, loading: true, success: false }),
    [MASTER_CONFIG_UPDATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.map((item) => item._id === payload.config._id ? payload.config : item),
      loading: false, error: null, success: true,
    }),
    [MASTER_CONFIG_UPDATE_FAIL]: (state, payload) => ({ ...state, loading: false, error: payload.error, success: false }),
    [MASTER_CONFIG_CLEAR]: () => ({ ...initialState }),
  },
  initialState
);
